import { FlagsProvider, useFlag } from '@zuruflex/api-client/react';
import { MaintenanceBanner } from '@zuruflex/ui';
import type { ReactNode } from 'react';
import { api } from './api.js';
import { useAuth } from './auth.js';

/**
 * The flags, for everything under the session.
 *
 * Inside `AuthProvider` because who is signed in is part of the question —
 * and of the query key, so switching accounts refetches rather than showing
 * one partner's flags to the next. No anonymous id: the portal is nothing
 * but a sign-in page until there is a partner, and a rollout keyed on
 * somebody who has not signed in yet has nothing to roll out to.
 */
export function PortalFlags({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  return (
    <FlagsProvider client={api} surface="partner" principalKey={user?.id ?? null}>
      <PortalMaintenanceBanner />
      {children}
    </FlagsProvider>
  );
}

/** Above every page, the sign-in screen included — downtime affects it too. */
function PortalMaintenanceBanner() {
  return <MaintenanceBanner value={useFlag('app.maintenanceBanner')} />;
}
